import createIcon from '../../createIcon';

/**
 * @component @name FoodBank
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgM0w0IDlWMjFIMjBWOUwxMiAzWk0xMi41IDEyLjVDMTIuNSAxMy4zMyAxMS44MyAxNCAxMSAxNFYxOEgxMFYxNEM5LjE3IDE0IDguNSAxMy4zMyA4LjUgMTIuNVY5LjVIOS41VjEyLjVIMTBWOS41SDExVjEyLjVIMTEuNVY5LjVIMTIuNVYxMi41Wk0xNSAxOEgxNFYxNC41SDEzVjExLjVDMTMgMTAuNCAxMy45IDkuNSAxNSA5LjVWMThaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FoodBank = createIcon('FoodBank', [
  [
    'path',
    {
      d: 'M12 3L4 9V21H20V9L12 3ZM12.5 12.5C12.5 13.33 11.83 14 11 14V18H10V14C9.17 14 8.5 13.33 8.5 12.5V9.5H9.5V12.5H10V9.5H11V12.5H11.5V9.5H12.5V12.5ZM15 18H14V14.5H13V11.5C13 10.4 13.9 9.5 15 9.5V18Z',
      key: '1yofq7',
    },
  ],
]);

export default FoodBank;
